import { connect } from 'react-redux'
import ErrorMessage from '../../components/errorMessage/errorMessageComponent'
import { State } from '../../../redux/reducers/'

export function mapStateToProps (state: State, props): Values {
  return {
    errors: state.login.errors
  }
}

export default connect(mapStateToProps)(ErrorMessage)



// WEBPACK FOOTER //
// ./src/forms/containers/loginErrorMessage/loginErrorMessageContainer.js